<template>
    <div v-if="hasPermission" v-bind:class="cssClass ? cssClass : 'invisible-wrap'">
        <slot/>
    </div>
    <div v-else-if="$slots.fallback !== undefined && $slots.fallback.length > 0" v-bind:class="cssClass ? cssClass : 'invisible-wrap'">
        <slot name="fallback"/>
    </div>
</template>

<style>
    .invisible-wrap {
        display: inline;
    }
</style>

<script>
  export default {
    props: {
      // Array of global permissions strings (eg, CREATE_SITE, DEVELOPER_MODE)
      requiredPermissions: Array,
      // CSS class to apply to the div (defaults to display: inline)
      cssClass: String
    },
    mounted() {
      this
          .$store
          .dispatch('fetchGlobalPermissions', {});
    },
    data () {
      return {}
    },
    computed: {
      hasPermission() {
        return this.$store.getters.hasGlobalPermissions({requiredPermissions: this.requiredPermissions});
      },
    }
  }
</script>